import { Fragment } from 'react';
import { taskRefHref } from '../comments/taskRefEncoding';
import { heldByReason, type RobotHeldBy } from '../../utils/robotHold';

/**
 * `formatHeldBy` with each ticket code rendered as the same task-ref chip that
 * `#MKS-12` references get in comments (MarkdownBody), so a held row links to
 * the task it waits for.
 */
export function HeldByText({ heldBy }: { heldBy: readonly RobotHeldBy[] }) {
  if (heldBy.length === 0) return <>Waiting</>;
  return (
    <>
      Waiting for{' '}
      {heldBy.map((h, i) => (
        <Fragment key={`${h.code}-${i}`}>
          {i > 0 && '; '}
          <a
            href={taskRefHref(h.code)}
            className="inline-flex items-center px-1.5 py-0.5 rounded-full bg-primary-50 text-primary-700 hover:bg-primary-100 no-underline text-sm font-medium"
            title="Open referenced task"
            data-task-ref
          >
            #{h.code}
          </a>{' '}
          ({heldByReason(h)})
        </Fragment>
      ))}
    </>
  );
}
